<script setup lang="ts">
import { RouterView } from 'vue-router';
import ToastViewport from './components/ToastViewport.vue';
</script>

<template>
    <RouterView />
    <ToastViewport />
</template>

<style>
/* Global styles if needed */
</style>
